<template>
  <div class="product-perm-wrap">
    <div class="header-title">产品权限分配</div>
    <div v-loading="loading">
      <div class="flex filter">
        <el-cascader
          v-model="filterData.userIdList"
          :options="userIdOptions"
          :props="{
            value: 'id',
            label: 'name',
            emitPath: false,
            multiple: true,
          }"
          filterable
          style="margin-left: 0; width: 260px"
          placeholder="请选择组织架构"
          collapse-tags
          clearable
          size="medium"
          @change="searchData(1)"
        ></el-cascader>
        <el-select
          filterable
          collapse-tags
          multiple
          clearable
          class="multiple-select"
          size="medium"
          placeholder="请选择用户"
          v-model="userInfListValue"
          @change="searchData(1)"
        >
          <el-option
            v-for="item in userList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <product-select
          :value.sync="filterData.afIdList"
          :multiple="true"
          placeholder="请选择产品"
          @change="searchData(1)"
          class="multiple-select"
          size="medium"
        >
        </product-select>
        <el-select
          filterable
          collapse-tags
          multiple
          clearable
          class="multiple-select"
          size="medium"
          placeholder="请选择平台类型"
          @change="searchData(1)"
          v-model="filterData.publishPlatformList"
        >
          <el-option
            v-for="item in marketTypeList"
            :key="item.refId"
            :label="item.name"
            :value="item.refId"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="filterData.mediaSourceList"
          placeholder="全部渠道"
          multiple
          size="medium"
          collapse-tags
          @change="changeSelect"
          class="multiple-select"
          ref="chnlref"
          popper-class="app-select-self"
        >
          <div class="input-search">
            <el-input v-model="text" size="mini" suffix-icon="el-icon-search" />
          </div>
          <el-checkbox v-model="checked" @change="selectAll($event, 'check')"
            >全选</el-checkbox
          >
          <!-- v-for="item in mediaList" -->
          <div @click="clickclear" class="clearbutton">
            <span style="font-size: 14px">清空</span>
          </div>

          <el-option
            class="option-item-selected"
            v-for="item in mediaList.filter(
              (i) => !text || i.toLowerCase().includes(text.toLowerCase())
            )"
            :key="item"
            :label="item"
            :value="item"
            :title="item"
          ></el-option>
        </el-select>
        <el-select
          filterable
          multiple
          clearable
          class="multiple-select"
          placeholder="请选择工作室"
          collapse-tags
          size="medium"
          v-model="filterData.groupNameList"
          @change="changegroupNameList"
        >
          <el-option
            v-for="item in groupList"
            :key="item.refId"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
        <el-select
          filterable
          multiple
          collapse-tags
          clearable
          class="multiple-select"
          size="medium"
          v-model="filterData.squadNameList"
          placeholder="请选择小组"
          @change="searchData(1)"
        >
          <el-option
            v-for="item in studioList"
            :key="item.refId"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="filterData.accountGroupCodes"
          placeholder="请选择域名组"
          clearable
          style="margin-left: 12px; width: 200px"
          size="medium"
          @change="searchData(1)"
        >
          <el-option
            v-for="item in accountGroupCodeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="flex">
        <div class="table-action">
          <el-button class="pl-btn" @click="showPlBox = true">
            <svg-icon iconClass="pl" className="plIcon"></svg-icon
            >批量操作</el-button
          >
          <span class="piliang border-bg" v-show="showPlBox">
            <span class="batch-span"
              >已选择<a>{{ multiSelection.length }}</a
              >产品</span
            >
            <div class="icon-list">
              <el-tooltip content="开启" placement="top">
                <svg-icon
                  iconClass="start"
                  className="batch-icon"
                  @click="editStatusMul(true)"
                ></svg-icon>
              </el-tooltip>
              <el-tooltip content="关闭" placement="top">
                <svg-icon
                  iconClass="stop"
                  className="batch-icon"
                  @click="editStatusMul(false)"
                ></svg-icon>
              </el-tooltip>
              <span class="close-icon">
                <svg-icon
                  iconClass="close"
                  className="close-btn"
                  @click="showPlBox = false"
                ></svg-icon>
              </span>
            </div>
          </span>
        </div>
        <div style="width: 400px; text-align: right; margin-top: 16px">
          <el-button type="primary" @click="changeAllStatus(true)"
            >全部开启</el-button
          >
          <el-button type="primary" @click="changeAllStatus(false)"
            >全部关闭</el-button
          >
          <el-tooltip
            class="item"
            effect="dark"
            content="将bi所有的产品权限同步到批量投放系统"
            placement="top-start"
          >
            <el-button type="primary" @click="syncBatchLaunch"
              >同步至批投</el-button
            >
          </el-tooltip>
        </div>
      </div>
      <el-table
        :height="tableHeight"
        :data="list"
        ref="table"
        @selection-change="handleSelectionChange"
        row-key="afid"
      >
        <el-table-column
          type="selection"
          reserve-selection
          width="55"
        ></el-table-column>
        <el-table-column label="唯一标识" prop="afid"></el-table-column>
        <el-table-column label="产品名称" prop="appName"></el-table-column>
        <el-table-column width="400" label="开启权限用户" v-if="isMultuip">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.permUserNames"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.permUserNames"
            >
              <div class="perm-names" slot="reference">
                {{ scope.row.permUserNames }}
              </div>
            </el-popover>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column width="400" label="权限开关" v-else>
          <template slot-scope="scope">
            <div class="mini-switch">
              <el-switch
                v-model="scope.row.isPerm"
                :active-value="true"
                :inactive-value="false"
                :disabled="
                  [...new Set([...userInfListValue, ...filterData.userIdList])]
                    .length === 0
                "
                @change="handlerSwitch($event, [scope.row])"
              ></el-switch>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <self-pagination
        class="footer-page"
        :total="pageData.total"
        :pageSize="pageData.size"
        :currentPage="pageData.page"
        @getCurrentPage="changePage"
        @handleSizeChange="handleSizeChange"
      ></self-pagination>
    </div>
  </div>
</template>

<script>
import { getmediaSourceFetch, productSyncBatchLaunch } from "@/api/api";
import {
  getProductPermList,
  getSquadList,
  getGroupList,
  getProductSimpleList,
  updateProductPerm,
} from "@/api/general.js";
import { getTagPropertySelectList, getProductUserList } from "@/api/property";
import SvgIcon from "@/components/SvgIcon.vue";
import { getRoleUserTree } from "@/api/account-management";

export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      getProductSimpleList,
      // 用户列表
      userInfListValue: [],
      accountGroupCodeList: JSON.parse(
        localStorage.getItem("accountGroupCodeList") || "[]"
      ),
      filterData: {
        // 组织架构
        userIdList: [],
        afIdList: [],
        groupNameList: [],
        squadNameList: [],
        // 平台类型
        publishPlatformList: [],
        mediaSourceList: [],
        accountGroupCodes: null,
      },
      text: "",
      checked: false,
      userIdOptions: [],
      groupList: [],
      studioList: [],
      mediaList: [],
      list: [],
      // 平台类型
      marketTypeList: [],
      userList: [],
      showPlBox: false,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableHeight: window.innerHeight - 385,
      multiSelection: [],
      isMultuip: false,
      loading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.initSelect();
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
  methods: {
    initSelect() {
      getRoleUserTree().then((res) => {
        this.userIdOptions = res.data;
      });
      getmediaSourceFetch().then((res) => {
        this.mediaList = res.mediaList;
      });
      this.searchData();
      getGroupList().then((res) => {
        this.groupList = res.data;
      });
      // 平台类型
      getTagPropertySelectList({ type: 10 }).then((res) => {
        this.marketTypeList = res.data;
      });
      // 用户
      getProductUserList().then((res) => {
        this.userList = res.data;
      });
      this.getSquadData();
    },
    getSquadData() {
      getSquadList({
        groupNameList: this.filterData.groupNameList?.join(","),
      }).then((res) => {
        this.studioList = res.data;
      });
    },
    clickclear() {
      this.filterData.mediaSourceList = [];
      this.searchData(1);
    },
    changeSelect(value) {
      if (
        this.checked &&
        this.filterData.mediaSourceList.length < this.mediaList.length
      ) {
        this.checked = false;
        this.filterData.mediaSourceList = value;
      }
      this.searchData(1);
    },
    selectAll(event, value) {
      if (event) {
        this.filterData.mediaSourceList = this.mediaList;
      } else {
        value == "check" ? (this.filterData.mediaSourceList = []) : null;
      }
    },
    refresh() {
      this.tableHeight = window.innerHeight - 310;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    changegroupNameList() {
      this.filterData.squadNameList = [];
      this.getSquadData();
      this.searchData(1);
    },
    changeCascaderVisible(flag) {
      if (flag) return;
      this.searchData(1);
    },
    resetFilter() {
      this.filterData = {
        userIdList: [],
        afIdList: [],
        groupNameList: [],
        squadNameList: [],
        publishPlatformList: [],
        mediaSourceList: [],
        accountGroupCodes: null,
      };
      this.changePage(1);
    },
    searchData(pageNum) {
      this.$nextTick(() => {
        this.loading = true;
        if (pageNum) this.pageData.page = pageNum;
        getProductPermList({
          pageNum: pageNum ? pageNum : this.pageData.page,
          pageSize: this.pageData.size,
          ...this.filterData,
          userIdList: [
            ...new Set([
              ...this.userInfListValue,
              ...this.filterData.userIdList,
            ]),
          ],
          accountGroupCodes: this.filterData.accountGroupCodes
            ? [this.filterData.accountGroupCodes]
            : undefined,
        }).then((res) => {
          if (res.code == "0000") {
            this.isMultuip =
              [
                ...new Set([
                  ...this.userInfListValue,
                  ...this.filterData.userIdList,
                ]),
              ].length > 1;
            this.list = res.data.list;
            this.pageData.total = res.data.total;
          }
          this.loading = false;
        });
      });
    },
    handleSelectionChange(data) {
      if (data.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.multiSelection = data;
    },
    handlerSwitch(flag, data) {
      if (
        [...new Set([...this.userInfListValue, ...this.filterData.userIdList])]
          .length == 0
      ) {
        this.$message.warning("请选择用户后再进行授权");
        return;
      }
      this.loading = true;
      updateProductPerm(data).then((res) => {
        if (res.code == "0000") {
          this.$message.success("编辑成功");
          this.changePage(1);
        }
        this.loading = false;
      });
    },
    changeAllStatus(flag) {
      if (
        [...new Set([...this.userInfListValue, ...this.filterData.userIdList])]
          .length == 0
      ) {
        this.$message.warning("请选择用户后再进行授权");
        return;
      }
      this.loading = true;
      updateProductPerm([
        {
          isPerm: flag,
          batchPerm: 1,
          ...this.filterData,
          userIdList: [
            ...new Set([
              ...this.userInfListValue,
              ...this.filterData.userIdList,
            ]),
          ],
        },
      ]).then((res) => {
        if (res.code == "0000") {
          this.$message.success("操作成功");
          this.changePage(1);
        }
        this.loading = false;
      });
    },
    editStatusMul(flag) {
      const data = JSON.parse(JSON.stringify(this.multiSelection));
      data.forEach((item) => {
        item.isPerm = flag;
        return item;
      });
      this.handlerSwitch(flag, data);
      this.$refs.table.clearSelection();
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    handleSizeChange(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    // 同步至批投
    syncBatchLaunch() {
      if (this.filterData.userIdList?.length > 0) {
        productSyncBatchLaunch(this.filterData.userIdList).then((res) => {
          if (res.code === "0000") {
            this.$message.success("同步成功");
          }
        });
      } else {
        this.$message.warning("请选择组织架构");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.product-perm-wrap {
  margin: 16px;
  height: calc(100vh - 120px);
  padding: 16px 24px 16px 24px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .header-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 15px;
    flex: 1;
    margin-bottom: 16px;
  }
  .filter {
    flex: 1;
    .multiple-select {
      margin-left: 8px;
      width: 240px;
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    /deep/ .el-cascader__search-input {
      min-width: 15px;
    }
  }
  .table-action {
    display: flex;
    align-items: center;
    padding: 9px 0px;
    width: 100%;
    height: 45px;
    .pl-btn {
      .plIcon {
        margin-right: 4px;
      }
      border: 1px solid #2a56e3;
      color: #2a56e3;
    }
    .piliang {
      height: 45px;
      line-height: 45px;
      padding-left: 12px;
      margin-left: 12px;
      display: flex;
      justify-content: space-between;
      .batch-span {
        font-size: 13px;
        color: rgba(0, 0, 0, 1);
        a {
          color: #2a56e3;
          margin: 0 5px;
        }
      }
      .icon-list {
        margin-left: 38px;
        color: #2a56e3;
      }
      .batch-icon {
        margin-right: 26px;
        cursor: pointer;
      }
      .close-btn {
        color: rgba(0, 0, 0, 0.6);
        font-size: 12px;
        margin: 0 16px 0 20px;
        cursor: pointer;
      }
    }
  }
  .perm-names {
    overflow: hidden; // 溢出的内容隐藏
    text-overflow: ellipsis; // 溢出的部分用省略号...显示
    -webkit-line-clamp: 2; // 行数
    display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
    -webkit-box-orient: vertical; // 设置或检索伸缩盒对象的子元素的排列方式
  }
}
</style>
